export default __webpack_public_path__ + "media/blog-pixel2-vertical.png";